import { FollowUpAction } from '@app/core/models';
import { createAction, props } from '@ngrx/store';
import { Pathology } from '@app/core/models/pathology';
/**
 * Actions to patch the form values in smart reco store
 * from existing patient, lastConsultation or renal detect recommendation
 */
export const setWeightManagementFormValues = createAction('[Weight Management] Set Form Values');
/**
 * Actions to set forms
 */
export const setWeightManagementPathologies = createAction('[Weight Management] Set Pathologies', props<{ value: Pathology[] }>());
/**
 * Action to set selected follow up action when doing a follow up visit
 */
export const setWeightManagementFollowUpAction = createAction(
  '[Weight Management] Set Follow Up Action',
  props<{ value: FollowUpAction }>(),
);
/**
 * Action to set the minimal bcs (use for stabilization visits)
 */
export const setMinimalBcs = createAction('[Weight Management] Set Minimal bcs', props<{ value: number }>());
